export const units = {
  pure: [
    { code: "P1", name: "Pure Mathematics 1", examCode: "WMA11", cashable: true },
    { code: "P2", name: "Pure Mathematics 2", examCode: "WMA12", cashable: true },
    { code: "P3", name: "Pure Mathematics 3", examCode: "WMA13", cashable: true },
    { code: "P4", name: "Pure Mathematics 4", examCode: "WMA14", cashable: true }
  ],
  further: [
    { code: "FP1", name: "Further Pure Mathematics 1", examCode: "WFM01", cashable: true },
    { code: "FP2", name: "Further Pure Mathematics 2", examCode: "WFM02", cashable: true },
    { code: "FP3", name: "Further Pure Mathematics 3", examCode: "WFM03", cashable: true }
  ],
  applied: [
    { code: "M1", name: "Mechanics 1", examCode: "WME01", cashable: true },
    { code: "M2", name: "Mechanics 2", examCode: "WME02", cashable: true },
    { code: "M3", name: "Mechanics 3", examCode: "WME03", cashable: true },
    { code: "S1", name: "Statistics 1", examCode: "WST01", cashable: true },
    { code: "S2", name: "Statistics 2", examCode: "WST02", cashable: true },
    { code: "S3", name: "Statistics 3", examCode: "WST03", cashable: true },
    { code: "D1", name: "Decision Mathematics 1", examCode: "WDM01", cashable: true }
  ]
}; 